import { D as g, L as x, R as C, T as y, m as R, a as S, u as v } from "./mergeRefs-CBC__vyO.js";
import { w as b } from "./uniqueSvgIds-KQABKtm8.js";
import { A as I } from "./AsyncStateController-BiW_uEVt.js";
import { useState as c, useRef as m, useCallback as f, useEffect as l } from "react";
function w(u, r = {
  successTTL: 2e3,
  errorTTL: 4e3
}) {
  const [a, t] = c(!1), [n, s] = c("default"), e = m(void 0), T = f(
    // @ts-expect-error Types do not matter here, this is only a proxy call.
    async (i) => {
      t(!0), e.current = window.setTimeout(() => s("loading"), 200);
      try {
        const o = await u(i);
        return clearTimeout(e.current), s("success"), r.successTTL !== "forwards" && (e.current = window.setTimeout(() => {
          s("default"), t(!1);
        }, r.successTTL ?? 2e3)), o;
      } catch (o) {
        throw clearTimeout(e.current), s("error"), e.current = window.setTimeout(() => {
          s("default"), t(!1);
        }, r.errorTTL ?? 4e3), o;
      }
    },
    [u, r.errorTTL, r.successTTL]
  );
  return l(() => () => {
    clearTimeout(e.current);
  }, []), [a ? void 0 : T, n, a];
}
export {
  I as AsyncStateController,
  g as DarkTheme,
  x as LightTheme,
  C as ReverseTheme,
  y as ThemeContext,
  R as mergeRefs,
  w as useAsyncFn,
  S as useCarousel,
  v as useControllableState,
  b as withUniqueIds
};
//# sourceMappingURL=lib.js.map
